import * as React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

const PhotoGallery = ({
  showLightbox,
  setShowLightbox,
  activeSlide,
  setActiveSlide,
  selectedImage,
  setSelectedImage,
}) => {
  return (
    <>
      <div className="textIntro"></div>
      <div className="container">
        <div className="foto1">
          <Link to="fotografies/eugeni-prieto-01">
            <StaticImage
              className="imageWrapLeft"
              src="../images/eugeni-01.jpg"
              alt="Blas"
            />
          </Link>
        </div>

        <div className="foto2">
          <Link to="fotografies/pau-guerrero-01">
            <StaticImage
              className="imageWrapRight"
              src="../images/pau-01.jpg"
              alt="Blas"
            />
          </Link>
        </div>
        <div className="foto3">
          <Link to="fotografies/eugeni-prieto-02">
            <StaticImage
              className="imageWrapLeft"
              src="../images/eugeni-02.jpg"
              alt="Blas"
            />
          </Link>
        </div>

        <div className="foto4">
          <Link to="fotografies/pau-guerrero-02">
            <StaticImage
              className="imageWrapRight"
              src="../images/pau-02.jpg"
              alt="Blas"
            />
          </Link>
        </div>
        <div className="foto5">
          <Link to="fotografies/eugeni-prieto-03">
            <StaticImage
              className="imageWrapLeft"
              src="../images/eugeni-03.jpg"
              alt="Blas"
            />
          </Link>
        </div>
        <div className="foto6">
          <Link to="fotografies/pau-guerrero-03">
            <StaticImage
              className="imageWrapRight"
              src="../images/pau-03.jpg"
              alt="Blas"
            />
          </Link>
        </div>
        <div className="foto7">
          <Link to="fotografies/eugeni-prieto-04">
            <StaticImage
              className="imageWrapLeft"
              src="../images/eugeni-04.jpg"
              alt="Blas"
            />
          </Link>
        </div>
        <div className="foto8">
          <Link to="fotografies/pau-guerrero-04">
            <StaticImage
              className="imageWrapRight"
              src="../images/pau-04.jpg"
              alt="Blas"
            />
          </Link>
        </div>
        <div className="foto9">
          <Link to="fotografies/eugeni-prieto-05">
            <StaticImage
              className="imageWrapLeft"
              src="../images/eugeni-05.jpg"
              alt="Blas"
            />
          </Link>
        </div>
        <div className="foto10">
          <Link to="fotografies/pau-guerrero-05">
            <StaticImage
              className="imageWrapRight"
              src="../images/pau-05.jpg"
              alt="Blas"
            />
          </Link>
        </div>
        <div className="foto11">
          <Link to="fotografies/eugeni-prieto-06">
            <StaticImage
              className="imageWrapLeft"
              src="../images/eugeni-06.jpg"
              alt="Blas"
            />
          </Link>
        </div>
        <div className="foto12">
          <Link to="fotografies/pau-guerrero-06">
            <StaticImage
              className="imageWrapRight"
              src="../images/pau-06.jpg"
              alt="Blas"
            />
          </Link>
        </div>
      </div>
    </>
  );
};

export default PhotoGallery;
